IREP.FourthGenLearningBand = (function() {
    var DoAnimation = function() {
        var ArabicAnim;
        CSSPlugin.defaultTransformPerspective = 600;

        var certificateTimeline = new TimelineLite();

        certificateTimeline
            .set($("#GenContent"), { display: "block" })
            .from($("#GenContent"), 1.5, { opacity: 0, scale: 0, transformOrigin: "center top", ease: Back.easeOut })
            //   .fromTo($("#GenContent"), .7, { width: 400, height: 200 }, { width: 415, height: 215 })
            .to($("#watchVideobar"), .25, { opacity: 1, width: "180px" })
            .to($("#watchVideobar"), .25, { height: "75px" }, "+=.25")

    };
    return {
        DoAnimation: DoAnimation
    };
})();